import { jsxs, jsx, Fragment } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { Common, Action } from "../../foundations/palette.es.js";
import { Spacing } from "../../foundations/spacing.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import { useState } from "react";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { AngleDownSmallOutlined as i$1 } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/angle-down-small-outlined.es.es.js";
import { AngleUpSmallOutlined as i } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/angle-up-small-outlined.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import ListItemButton from "../../../node_modules/@mui/material/ListItemButton/ListItemButton.es.js";
import ListItemIcon from "../../../node_modules/@mui/material/ListItemIcon/ListItemIcon.es.js";
import ListItemText from "../../../node_modules/@mui/material/ListItemText/ListItemText.es.js";
import Collapse from "../../../node_modules/@mui/material/Collapse/Collapse.es.js";
function NavigationListItemCollapsible({
  label,
  icon,
  subpaths,
  children,
  ...rest
}) {
  const [open, setOpen] = useState(false);
  const endIcon = open ? /* @__PURE__ */ jsx(i, { color: "action" }) : /* @__PURE__ */ jsx(i$1, { color: "action" });
  function handleToggle() {
    setOpen((prevOpen) => !prevOpen);
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(ListItemButton, { onClick: handleToggle, ...rest, children: [
      /* @__PURE__ */ jsx(ListItemIcon, { children: icon }),
      /* @__PURE__ */ jsx(ListItemText, { primary: label }),
      endIcon
    ] }),
    /* @__PURE__ */ jsx(Collapse, { in: open, timeout: "auto", unmountOnExit: true, children })
  ] });
}
function NavigationListItem({
  label,
  icon,
  disabled,
  ...rest
}) {
  const [selected, setSelected] = useState(false);
  function handleClick() {
    setSelected((selected2) => !selected2);
  }
  return /* @__PURE__ */ jsxs(ListItemButton, { onClick: handleClick, selected, disabled, ...rest, children: [
    /* @__PURE__ */ jsx(ListItemIcon, { sx: {
      color: selected ? Common.white.main : Action.active,
      minWidth: disabled && !icon ? Spacing["0"] : Spacing["3500"]
    }, children: icon }),
    /* @__PURE__ */ jsx(ListItemText, { primary: label })
  ] });
}
export {
  NavigationListItem,
  NavigationListItemCollapsible
};
//# sourceMappingURL=navigation-list-item.es.js.map
